// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportLeftNavigation.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');

  var Tabs = require('share/components/controls/Izenda.Tab').Tabs;
  var Tab = require('share/components/controls/Izenda.Tab').Tab;
  var CategoryTree = require('share/components/controls/CategoryTree/Izenda.CategoryTree');
  var routeUtils = require('share/utils/Izenda.RouteUtils');
  var LicenseCheckerConstants = require('logic/data/Izenda.LicenseCheckerConstants');

  var CONSTANTS = require('logic/data/Izenda.ReportsConstants');
  var CATEGORY_TYPE = CONSTANTS.CATEGORY_TYPE;

  var compare = require('share/utils/Izenda.PropsComparison');
  const { isEqual, toString } = require('lodash/fp');

  var ReportLeftNavigation = React.createClass({
    propTypes: {
      store: React.PropTypes.object
    },

    componentWillReceiveProps: function(nextProps) {
      const nextStore = nextProps.store;
      const nextReportType = nextProps.reportType;
      const { store, reportType } = this.props;

      if (!compare(nextStore, store) || !isEqual(nextReportType, reportType) || nextProps.isReload) {
        const loader = nextProps.loader;
        const reportType = nextReportType || nextStore.reportType;

        loader.startLoading();
        nextStore.loadLazyLoadingCategories(reportType, true).finally(loader.endLoading.bind(loader));
      }
    },

    render: function() {
      var props = this.props;
      var localization = props.localization;
      var store = props.store;
      var reportType = props.reportType || store.reportType;
      var authorization = props.authorization;
      var hasTemplateLicense = authorization.checkLicense(LicenseCheckerConstants.LICENSE_KEY.ReportTemplateComponent);

      var reportTabRouteParams = {
        reportType: { dataKey: '', value: CATEGORY_TYPE.REPORT },
        catId: { dataKey: 'id', value: null },
        isGlobal: { dataKey: 'isGlobal', value: null }
      };

      var templateTabRouteParams = {
        reportType: { dataKey: '', value: CATEGORY_TYPE.TEMPLATES },
        catId: { dataKey: 'id', value: null },
        isGlobal: { dataKey: 'isGlobal', value: null }
      };

      const reportLink = getLink.call(this, CATEGORY_TYPE.REPORT);
      const templateLink = getLink.call(this, CATEGORY_TYPE.TEMPLATES);

      return (
        <div>
          <Tabs activeTabKey={toString(reportType)} className='left-tab' navigationClass='u-bgDarkBlue'>
            <Tab
              title={localization.getText('COMMON_LABEL_REPORTS')}
              tabKey={CATEGORY_TYPE.REPORT}
              href={reportLink}
              className='u_fullHeight'
            >
              {this.renderCategoryTree(
                reportTabRouteParams,
                store.model.leftMenuReportCategoryTree,
                store.model.isLeftMenuReportLastPage
              )}
            </Tab>
            {hasTemplateLicense && (
              <Tab
                title={localization.getText('COMMON_LABEL_TEMPLATES')}
                tabKey={CATEGORY_TYPE.TEMPLATES}
                href={templateLink}
                className='u_fullHeight'
              >
                {this.renderCategoryTree(
                  templateTabRouteParams,
                  store.model.leftMenuTemplateCategoryTree,
                  store.model.isLeftMenuTemplateLastPage
                )}
              </Tab>
            )}
          </Tabs>
        </div>
      );

      function getLink(reportType) {
        return routeUtils.getReportUrl('List', {
          reportType: reportType,
          isGlobal: null
        });
      }
    },

    /**
     * Render Report Category Tree
     * @param {object} routeParams
     */
    renderCategoryTree: function(routeParams, dataTree, isLastPage) {
      var props = this.props;
      var store = props.store;
      var reportType = props.reportType || store.reportType;

      return (
        <CategoryTree
          store={store}
          reportType={reportType}
          dataTree={dataTree}
          isLastPage={isLastPage}
          selectedCategoryId={store.selectedCategoryId}
          routeObject={routeUtils.getConfigRoute('Report', 'List')}
          routeParams={routeParams}
          onDeleteCategory={store.deleteReportCategory.bind(store)}
          onLoadCategoryList={handleLoadReportList}
          onValidateCategoryName={store.validateCategoryName.bind(store)}
          registerLazyLoadingStore={store.registerLeftMenuLazyLoadingStore.bind(store)}
          getData={store.loadLazyLoadingCategories.bind(store, reportType, false)}
        />
      );

      /**
       * Load Report List with category ID and type of report
       * @param catId
       * @returns {Promise}
       */
      function handleLoadReportList(catId) {
        return store.loadLazyLoadingReports(catId, reportType, true, null);
      }
    }
  });

  module.exports = connect()(ReportLeftNavigation);
})();



// WEBPACK FOOTER //
// ./ui/modules/Reports/Izenda.ReportLeftNavigation.jsx